import { render } from "./dash-header.vue?vue&type=template&id=044ceed2&scoped=true"
import script from "./dash-header.vue?vue&type=script&lang=js"
export * from "./dash-header.vue?vue&type=script&lang=js"

import "@/assets/css/dashStyle.css?vue&type=style&index=0&id=044ceed2&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-044ceed2"]])

export default __exports__